<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <p class="title">
          {{`使用结束`}}
        </p>
        <img src="../assets/img/resources/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="inputer">
        <input type="text" :placeholder="`请输入设备编号`" v-model="info.number">
      </div>
      <div class="remark">
        <textarea placeholder="备注" v-model="remark">
        </textarea>
        <span class="count">{{`${remark.length}/200`}}</span>
      </div>
      <div class="btn" @click="confirm()">
        保存
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
  name: 'equipmentLoan',
  data() {
    return {
      show: false,
      remark: '',
      info: {
        number: ''
      }
    }
  },
  methods: {
    open(l) {
      this.info.number = l
      this.show = true
    },
    close() {
      this.show = false
    },
    confirm() {
      const info = {
        task_id: this.info.number,
        end_remark: this.remark
      }

      common.myFetch(apis.Res_device_task_finish, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.close()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1000;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 680px;
    height: auto;
    padding: 20px 30px;
    .headline {
      height: 34px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .title {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        cursor: pointer;
      }
    }
    .inputer {
      height: 40px;
      border-radius: 4px;
      background-color: rgba(185, 195, 195, 0.2);
      display: flex;
      padding: 10px 20px;
      margin-bottom: 13px;
      input {
        background-color: transparent;
        flex: 1;
        font-size: 14px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
          font-size: 14px;
        }
      }
    }
    .remark {
      height: 200px;
      border-radius: 4px;
      border: 1px solid #dcdcdc;
      margin: 20px 0;
      padding: 14px 20px 28px;
      position: relative;
      textarea {
        width: 100%;
        height: 100%;
        background-color: transparent;
        resize: none;
        font-size: 16px;
        color: @dark;
        &::placeholder {
          color: @dateColor;
        }
      }
      .count {
        font-size: 16px;
        color: @dateColor;
        bottom: 8px;
        right: 18px;
        position: absolute;
      }
    }
    .btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 100px;
      background-color: @green;
      color: #fff;
      font-size: 14px;
      margin: 0 auto;
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
  }
}
</style>
